import type { ClearIndicatorProps, GroupBase } from 'react-select';
import { VpIcon } from '@vtmn-play/react/headless';
import { components } from 'react-select';

export function ClearIndicator<T>(props: Readonly<ClearIndicatorProps<T, true, GroupBase<T>>>) {
  return (
    <components.ClearIndicator {...props}>
      <VpIcon name="close" />
    </components.ClearIndicator>
  );
};
